import { DateTime } from 'luxon';

import { ViewTable } from '@/configs/ViewTable';

import { getWorkdaysInMonth } from './getWorkdaysInMonth';

export const getColorByMinutes = (
  minutes: number,
  workTime: number,
  view?: ViewTable,
  currentDate?: DateTime<boolean>,
) => {
  const workdays = view === ViewTable.Month && currentDate ? getWorkdaysInMonth(currentDate) : 5;

  if (minutes === 0) return 'var(--danger-color)';

  if (minutes >= (workTime / 5) * 60 * workdays) return 'var(--success-color)';

  return 'var(--info-color)';
};
